/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { InteractivePopout } from "./InteractivePopout"
import { Grid, Spacer } from "@cd2/components"
import { doo } from "@cd2/tools"

interface IPopOutPanelProps {
  children: (state: {
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  }) => React.ReactNode
  title: string
  content: (state: {
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  }) => React.ReactNode
  footer?: (state: {
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  }) => React.ReactNode
  width?: number | string
  maxWidth?: number
  setIsOpenRef?: React.MutableRefObject<(state: boolean) => void | null>
}

export function PopOutPanel({
  setIsOpenRef,
  children,
  title,
  content,
  footer,
  width,
  maxWidth,
}: IPopOutPanelProps) {
  return (
    <InteractivePopout
      maxWidth={maxWidth}
      content={state => (
        <div
          css={css`
            width: ${doo(() => {
              if (width) {
                return typeof width === "number" ? `${width}px` : width
              }
              return "340px"
            })};
          `}
        >
          <Grid
            css={css`
              border-bottom: 1px solid #ddd;
              padding: 20px;
            `}
          >
            <div
              css={css`
                font-weight: 600;
              `}
            >
              {title}
            </div>
          </Grid>
          <div
            css={css`
              padding: 12px;
              max-height: 300px;
              overflow: auto;
            `}
          >
            {content(state)}
          </div>
          <Spacer size={12} />
          {footer && <div>{footer(state)}</div>}
        </div>
      )}
    >
      {({ isOpen, setIsOpen }) => {
        if (setIsOpenRef) {
          setIsOpenRef.current = setIsOpen
        }
        return children({ isOpen, setIsOpen })
      }}
    </InteractivePopout>
  )
}
